import { motion } from "framer-motion";

import heroBg from "@/assets/hero-bg.jpg";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex flex-col justify-end overflow-hidden bg-carbon dark:bg-carbon">
      {/* Person image - right side (desktop) */}
      <div className="absolute right-0 top-0 bottom-0 w-[55%] hidden md:block">
        <img
          src={heroBg}
          alt="Profissional da nova era do direito"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          width={1920}
          height={1080}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-carbon via-carbon/60 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-carbon via-transparent to-transparent" />
      </div>

      {/* Person image - mobile */}
      <div className="absolute inset-0 md:hidden">
        <img
          src={heroBg}
          alt="Profissional da nova era do direito"
          className="w-full h-full object-cover object-[60%_10%]"
          fetchPriority="high"
          width={1080}
          height={1920}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/50 to-transparent" />
      </div>

      {/* Purple spotlight glow */}
      <div className="absolute top-0 right-[30%] w-[500px] h-[600px] bg-electric-purple/30 rounded-full blur-[150px] pointer-events-none" />
      <div className="absolute top-[10%] right-[25%] w-[300px] h-[400px] bg-electric-purple/20 rounded-full blur-[100px] pointer-events-none" />

      {/* Content */}
      <div className="container relative z-10 mx-auto px-6 pb-[80px] pt-40 md:pt-[120px] md:pb-[120px]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0 }}
          className="max-w-3xl"
        >
          <h1 className="font-display text-[clamp(2.5rem,5.5vw,4.5rem)] font-bold leading-[1.05] tracking-tight text-pearl">
            Aprenda arbitragem com quem administra casos reais.
          </h1>
          <p className="mt-4 max-w-[560px] text-[16px] md:text-[18px] font-normal text-pearl/85" style={{ lineHeight: 1.6 }}>
            A Emera é a escola da Arbitralis SA, câmara com +30.000 casos resolvidos.
          </p>
          <a
            href="#cursos"
            onClick={(e) => {
              const el = document.getElementById("cursos");
              if (el) {
                e.preventDefault();
                el.scrollIntoView({ behavior: "smooth" });
              }
            }}
            className="mt-8 inline-flex items-center justify-center rounded-lg bg-electric-purple text-pearl font-medium text-[15px] px-7 py-[13px] hover:opacity-90 transition-opacity"
          >
            Ver cursos
          </a>
        </motion.div>

        {/* Minimalist stats row */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.6 }}
          className="mt-14 border-t border-pearl/10 pt-8 pb-6 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-6 max-w-4xl"
        >
          <div>
            <p className="font-display text-[clamp(2rem,3.2vw,2.75rem)] font-bold leading-none tracking-tight text-pearl">
              +30.000
            </p>
            <p className="mt-2 text-[13px] leading-snug text-pearl/60 max-w-[220px]">
              casos resolvidos pela Arbitralis SA
            </p>
          </div>
          <div className="md:pl-6 md:border-l md:border-pearl/10">
            <p className="font-display text-[clamp(2rem,3.2vw,2.75rem)] font-bold leading-none tracking-tight text-pearl">
              +100.000
            </p>
            <p className="mt-2 text-[13px] leading-snug text-pearl/60 max-w-[220px]">
              negociações conduzidas em todo o Brasil
            </p>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default HeroSection;
